VP = window.VP || {};

(function( $ ) {
	VP.generalContentGrid = {
		contentData: [],
		contentPostPosition: 18,
		postPerLoad: 18,
		totalContentPosts: null,
		selectedList: null,
		pagePostType: null,
		tagPage: null,
		slugType: null,
		categoryFilter: null,
		areaFilter: null,
		tagFilter: null,
		currentPostId: null,
        currentSlug: null,
		hotelPage:false,
		currentPage:1,
		selector: {
			contentGrid: $('.vp-general-content-grid'),
			contentGridBtn: $('.js-general-content-grid-btn'),
			contentGridList: $('.vp-general-content-grid__list')
		},

		init: function () {
			var _this = this;

			_this.currentPage = parseInt(VP.helpers.getQParams("cpage"));
			if (isNaN(_this.currentPage)) {
				_this.currentPage = 1;
			}

			_this.contentPostPosition = _this.contentPostPosition * _this.currentPage;

			_this.totalContentPosts = _this.selector.contentGrid.attr('data-contentNo');
			_this.selectedList = _this.selector.contentGrid.attr('data-selectedlist');
			_this.pagePostType = _this.selector.contentGrid.attr('data-pageposttype');
			_this.tagPage = _this.selector.contentGrid.attr('data-tagpage');
			_this.slugType = _this.selector.contentGrid.attr('data-slugtype');
			_this.categoryFilter = _this.selector.contentGrid.attr('data-categoryfilter');
			_this.areaFilter = _this.selector.contentGrid.attr('data-areafilter');
			_this.tagFilter = _this.selector.contentGrid.attr('data-tagfilter');
			_this.currentPostId = _this.selector.contentGrid.attr('data-currentPostId');
            _this.currentSlug = _this.selector.contentGrid.attr('data-currentSlug');
			_this.hotelPage = (_this.selector.contentGrid.attr('data-hotelPage') == "true");

			VP.helpers.detectMobile();
			_this.init_iosTouchOverrides();

			// only show load more button if there are more content to load
			if (_this.totalContentPosts >= _this.postPerLoad) {
				_this.selector.contentGridBtn.fadeIn(200)
					.on('click', _this.loadAjaxRequest.bind( _this, _this.contentPostPosition, _this.postPerLoad) );
			}
		},


		// Remove hover effect on iOS Devices so user does not have to double tap on links
		init_iosTouchOverrides: function() {
			if ( $('body').hasClass('is-iOS') ) {
				$('.vp-content-grid__item-wrap').removeClass('not-ios');
			}
		},

		displayButtonCheck: function() {
			var _this = this;

			// Remove button if there are no more content to display
			if (_this.contentPostPosition >= _this.totalContentPosts) {
				_this.selector.contentGridBtn.fadeOut(200).remove();
			}
		},

		loadAjaxRequest: function() {
			var _this = this;



			var startPos = _this.contentPostPosition;
			var endPos =  _this.contentPostPosition + _this.postPerLoad;

			// change end position if the total amount of posts remaining is less than default load amount
			if (endPos > _this.totalContentPosts) {
				endPos = parseInt(_this.totalContentPosts);
			}

			var trimList = _this.selectedList.split('"').join('');




			if (_this.selector.contentGridBtn.hasClass('vp-general-content-grid__btn--busy')) {
				return;
			}

			// show dot animation while content is loading
			_this.selector.contentGridBtn.addClass('vp-general-content-grid__btn--busy');



			var exclusions = [];

			if ( _this.hotelPage ) {
				// for hotel page, include exclusions, and reset content positioning for random selection
				_this.selector.contentGridList.find(".vp-content-grid__item").each(function() {
					exclusions.push($(this).data("id"));
				});
				startPos = 0;
				endPos = _this.postPerLoad;
			}
			var exclude = exclusions.join(",");

			// Fire off the request to ajax.php
			VP.request.get(
				'general_content_grid_get_list',
				{
					postStart: startPos,
					postEnd: endPos,
					postSelected: trimList,
					postType: _this.pagePostType,
					tagPage: _this.tagPage,
					slugType: _this.slugType,
					categoryFilter: _this.categoryFilter,
					areaFilter: _this.areaFilter,
					tagFilter: _this.tagFilter,
					currentPostId: _this.currentPostId,
                    currentSlug: _this.currentSlug,
					hotelPage: _this.hotelPage,
					exclude: exclude
				},
				function ( response ) {
					_this.insertNewContent(response);
					_this.selector.contentGridBtn.removeClass('vp-general-content-grid__btn--busy');

					// Paging doesn't work on hotelpage due to randomization
					if ( ! _this.hotelPage ) {
						_this.currentPage = _this.currentPage + 1;
						VP.helpers.setQParams( { cpage:_this.currentPage } , {type:"replace"} );
					}
				},
				function ( error, xhr ) {
					console.error("Unable to load more content.");
					_this.selector.contentGridBtn.removeClass('vp-general-content-grid__btn--busy');
				}
			);
		},

		insertNewContent: function(newContent) {
			var _this = this;
			_this.selector.contentGridList.append(newContent);

			//set the new start position when loading next series of content;
			_this.contentPostPosition = _this.contentPostPosition + _this.postPerLoad;

			//remove button if all the content posts have been loaded.
			_this.displayButtonCheck();

			//remove hover state on iOS for new content items
			_this.init_iosTouchOverrides();

			//reset Reveal metrics since height of page has changed
			VP.reveal.updatePosition();
		}
	};
})(jQuery);
